<div class="verify-domain-container">
  <div class="input-wrapper" [class.success]="currentStatus === 'success'" [class.warning]="currentStatus === 'warning'" [class.loading]="currentStatus === 'loading'" [class.error]="currentStatus === 'error'">
    <div class="floating-label-container">
      <input [id]="uniqueId" type="text" [formControl]="domainControl" [class]="getInputClass()" maxlength="253"
        (input)="onInputChange($event)" (focus)="onFocus()" (blur)="onBlur()" (keydown)="blockAtSymbol($event)"
        [ngStyle]="{'border': getBorder(),'border-radius': getBorderRadius()}" />

      <label class="floating-label" [for]="uniqueId" [class.active]="domainValue || isFocused">
        {{ label }}
      </label>

      <div class="right-content">
        <span *ngIf="currentStatus === 'success'" class="mdn-Icon-check success-icon"></span>
        <span *ngIf="currentStatus === 'warning'" class="mdn-Icon-circulo-exclamacao warning-icon"></span>
        <span *ngIf="currentStatus === 'loading'" class="mdn-Icon-relogio loading-icon"></span>
        <span *ngIf="currentStatus === 'error'" class="mdn-Icon-fechar error-icon"></span>

        <span class="domain-suffix" *ngIf="domainSuffix">{{ domainSuffix }}</span>
      </div>
    </div>
  </div>

  <div
    *ngIf="shouldShowFeedback"
    class="feedback-card"
    [ngClass]="currentStatus"
  >
    <span class="feedback-icon" [ngClass]="feedbackIcon"></span>

    <div class="feedback-content">
      <h4 class="feedback-title">
        {{ title }}
      </h4>

      <p class="feedback-text">
        {{ description }}
      </p>
    </div>
  </div>
</div>